import { colord } from "colord";

const COLOR_LEVELS = [
  "20",
  "50",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
];

export const generatePrimaryPalette = (baseHex: string) => {
  const palette: Record<string, string> = {};
  const { l: baseL, c, h } = colord(baseHex).toLch();

  const lightnessRange = { min: 10, max: 95 };
  const indexOfBase = COLOR_LEVELS.indexOf("500");
  const step =
    (lightnessRange.max - lightnessRange.min) / (COLOR_LEVELS.length - 1);

  COLOR_LEVELS.forEach((level, i) => {
    const offset = (i - indexOfBase) * step;
    const l = Math.max(
      lightnessRange.min,
      Math.min(lightnessRange.max, baseL - offset)
    );
    palette[level] = colord({ l, c, h }).toHex();
  });

  return palette;
};
